import Swiper, { Navigation, Autoplay } from "swiper";

const UiCarousel = class extends HTMLElement {
  connectedCallback() {
    const slider = document.createElement("div");
    const wrapper = document.createElement("div");
    const nextBtn = document.createElement("button");
    const prevBtn = document.createElement("button");
    const slides = this.children;
    const id = `carousel-${Math.floor(Math.random() * 1000000000)}`;

    slider.classList.add("swiper");
    slider.id = id;
    wrapper.classList.add("swiper-wrapper");

    nextBtn.classList.add("next-btn", "button", "button--carousel", "button--white");
    nextBtn.innerHTML = `<svg><use xlink:href="#icon-chevron-right-small"></use></svg>`;

    prevBtn.classList.add("prev-btn", "button", "button--carousel", "button--white");
    prevBtn.innerHTML = `<svg><use xlink:href="#icon-chevron-left-small"></use></svg>`;

    for (const slide of slides) {
      slide.classList.add("swiper-slide");
      wrapper.appendChild(slide.cloneNode(true));
    }

    this.innerHTML = "";
    slider.appendChild(wrapper);
    slider.appendChild(prevBtn);
    slider.appendChild(nextBtn);
    this.appendChild(slider);

    new Swiper(slider, {
      loop: true,
      modules: [Navigation, Autoplay],
      speed: 400,
      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: `#${id} .next-btn`,
        prevEl: `#${id} .prev-btn`,
      },
    });
  }
};

customElements.define("ui-carousel", UiCarousel);
